// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iTAeNTgGepM8fcKMRSCP{text-underline-offset:2px;color:var(--interaction-brand-active);cursor:pointer;text-decoration:underline;text-decoration-thickness:1.5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clickableValue": `iTAeNTgGepM8fcKMRSCP`
};
export default ___CSS_LOADER_EXPORT___;
